// extracted by mini-css-extract-plugin
export default {"modal":"MarginModal_modal__79VQx","content":"MarginModal_content__SVphZ","input":"MarginModal_input__zskAh","btnWrapper":"MarginModal_btnWrapper__1Hq89"};